export class Asset {
    constructor(id) {
        const assetsURL = process.env.CMS_ASSETS_URL ? process.env.CMS_ASSETS_URL : '';
        this.fullUrl = `${assetsURL}${id}`;
    }
}
